export interface IAccount {
  username: string
  lastname: string
  idcard: string
  telephone: string
  Address: string
  street:string
  province: string
  City: string
  district: string
  postcode: string
  email: string
  language: string
  timeZone: string
  Consent1: boolean
  Consent2: boolean
  Consent3: boolean
  submitbut: boolean
  communications: {
    email: boolean
    sms: boolean
    phone: boolean
  }
  gender: {
    Male: boolean
    Female: boolean
    NotSpecified: boolean
  }
  requireInfo: boolean
}

export const defaultAccount: IAccount = {
  username: 'bangkoksync',
  lastname:'bangkoksync',
  email: 'bangkoksync@loop.com',
  telephone:'0868138285',
  Address:'30/165',
  street:'ถนน',
  language: 'th',
  timeZone: 'Bangkok',
  province: 'กรุงเทพมหานคร',
  City: 'เขตยานนาวา',
  district: 'แขวงช่องนนทรี',
  idcard:'115236476586',
  postcode: '10120',
  Consent1: true,
  Consent2: true,
  Consent3: true,
  submitbut: true,
  communications: {
    email: true,
    sms: false,
    phone: false,
  },
  gender: {
    Male: true,
    Female: false,
    NotSpecified: false,
  },
  requireInfo: false,
}


export interface IAccountcustomer {
  email: string
  requireInfo: string
  timeZone: string
  username: string

}

export const defaultAccountcustomer: IAccountcustomer = {
  email: 'bangkoksync',
  requireInfo:'bangkoksync',
  timeZone: 'bangkoksync@loop.com',
  username:'0868138285',

}
